__turbopack_context__.v({
  "pollblock": "PollBlock-module-sass-module__ujUI3a__pollblock",
  "pollblock--editable": "PollBlock-module-sass-module__ujUI3a__pollblock--editable",
  "pollblock--picked": "PollBlock-module-sass-module__ujUI3a__pollblock--picked",
  "pollblock__options": "PollBlock-module-sass-module__ujUI3a__pollblock__options",
  "pollblock__options--picked": "PollBlock-module-sass-module__ujUI3a__pollblock__options--picked",
  "pollblock__options__option": "PollBlock-module-sass-module__ujUI3a__pollblock__options__option",
  "pollblock__options__option--discarded": "PollBlock-module-sass-module__ujUI3a__pollblock__options__option--discarded",
  "pollblock__options__option--picked": "PollBlock-module-sass-module__ujUI3a__pollblock__options__option--picked",
  "pollblock__options__option__answer": "PollBlock-module-sass-module__ujUI3a__pollblock__options__option__answer",
  "pollblock__options__option__bar": "PollBlock-module-sass-module__ujUI3a__pollblock__options__option__bar",
  "pollblock__options__option__percentage": "PollBlock-module-sass-module__ujUI3a__pollblock__options__option__percentage",
});
